import { ArTranEntity, BaseArTranLabels, UnallocatedArTranIdsByClient } from '@anduin/api';
import { DEFAULT_LOADABLE_STATE, Loadable } from '@anduin/shared';
import {
  NewTransactionOption,
  TransactionsSidebarMode,
  TransactionsTableExternalFilters,
  getDefaultTransactionsTableExternalFilters,
} from '../models';

export type ArManagementStateModel = ArManagementCommonStateModel & ArManagementFeatureStateModel;

export interface ArManagementCommonStateModel {
  // meta/underlying/persistent/misc.
  arTranLabels: Loadable<BaseArTranLabels>;

  // meta/underlying/persistent/misc.
  unallocatedArTranIdsByClient: Loadable<UnallocatedArTranIdsByClient>;

  // stashes (for feature module rehydration)
  featureStateStashes?: ArManagementFeatureStateStashes;
  activeStashName?: string; // follows this pattern: 'entity/feature.id' where id is optional (e.g. 'client.43' or 'payments')
}

export interface ArManagementFeatureStateModel {
  // setup/mode
  context: Loadable<ArManagementFeatureStateContext>;
  transactionsTableExternalFilters: TransactionsTableExternalFilters;
  transactionsSidebarMode?: TransactionsSidebarMode;
  selectedNewTransactionOption?: NewTransactionOption;
  areTransactionSidebarChangesPending?: boolean;

  // entities
  selectedArTran: Loadable<ArTranEntity>;
  linkedArTrans: Loadable<ArTranEntity[]>;
  linkableArTrans: Loadable<ArTranEntity[]>;
}

export type ArManagementFeatureStateStashes = Record<string, ArManagementFeatureStateModel>;

export interface ArManagementFeatureStateContext {
  scope: ArManagementFeatureStateScope;
}

export interface ArManagementFeatureStateScope {
  clientIds: number[];
}

export const AR_MANAGEMENT_STATE_MODEL_DEFAULT: ArManagementStateModel = {
  arTranLabels: DEFAULT_LOADABLE_STATE,
  unallocatedArTranIdsByClient: DEFAULT_LOADABLE_STATE,

  context: DEFAULT_LOADABLE_STATE,
  transactionsTableExternalFilters: getDefaultTransactionsTableExternalFilters(),
  selectedArTran: DEFAULT_LOADABLE_STATE,
  linkedArTrans: DEFAULT_LOADABLE_STATE,
  linkableArTrans: DEFAULT_LOADABLE_STATE,
};
